//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">VPS购买流程</div>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon1.png')}"/>
                  </p>
                  <p class="bold">
                      VPS产品参数
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2.png')}"/>
                  </p>
                  <p class="bold">
                      VPS申请步骤
                  </p>
                  <p>
                      1、打开WikiFX APP，进入首页，点击【VPS】进入VPS开通流程
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3.png')}"/>
                  </p>
                  <p>
                      2、选择所需云主机
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4.png')}"/>
                  </p>
                  <p>
                      3、【选择服务器】，选择离交易商服务器地址最近的为佳，选择后不可更改，若需更改注销VPS重新购买。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5.png')}"/>
                  </p>
                  <p>
                      4、【选择VPS语言】，选择您常用的系统语言。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6.png')}"/>
                  </p>
                  <p>
                      5、设置您的服务器密码
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7.png')}"/>
                  </p>
                  <p>
                      6、确认您的订单信息，请使用金币支付（需通过APP内部购买金币）。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8.png')}"/>
                  </p>
                  <p>
                      7、确认订单信息，记录好“服务器IP地址”、“账号”、“密码”，建议截图保存，以防忘记。当所有注册步骤完成后，建议10分钟后，再进行登录。
                  </p>`,
        zh: `
        <div class="title-box">VPS購買流程</div>
            <p class="bold">
                VPS產品參數
            </p>
            <p class="m30">
                <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
            </p>
            <p class="bold">
                VPS申請步驟
            </p>
            <p>
                1.開啟WikiFX APP，進入首頁，點選【VPS】進入VPS開通流程
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
            </p>
            <p>
                2、選擇所需雲端主機
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
            </p>
            <p>
                3.【選擇伺服器】，選擇離交易商伺服器位址最近的為佳，選擇後不可更改，若需更改註銷VPS重新購買。
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
            </p>
            <p>
                4.【選擇VPS語言】，選擇您常用的系統語言。
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
            </p>
            <p>
                5、設定您的伺服器密碼
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
            </p>
            <p>
                6、確認您的訂單訊息，請使用金幣付款（需透過APP內部購買金幣）。
            </p>
            <p class="m30">
                <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
            </p>
            <p>
                7、確認訂單訊息，記錄好“伺服器IP位址”、“帳號”、“密碼”，建議截圖保存，以防忘記。 當所有註冊步驟完成後，建議10分鐘後，再登入。
            </p>
            <p>
                <span class="lark-record-clipboard"></span>
            </p>
            <p>
                <br/>
            </p>`,
        en: `
        <div class="title-box">VPS purchase process</div>
                  <p class="bold">
                      VPS product parameters
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      VPS application steps
                  </p>
                  <p>
                      1.Open WikiFX APP, enter the homepage, click [VPS] to enter the VPS activation process
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <p>
                      2.Select the desired cloud host
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <p>
                      3.[Select server], choose the closest to the dealer server address is best, after the selection cannot be changed, if you need to change the VPS cancellation and re-purchase.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <p>
                      4. [Select VPS language], select your commonly used system language.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <p>
                      5. Set your server password
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <p>
                      6.Confirm your order information, please pay with gold coins (gold coins need to be purchased through the APP).
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <p>
                      7.Confirm the order information and record the &quot;server IP address&quot;, &quot;account number&quot; and &quot;password&quot;. It is recommended to take a screenshot and save it in case you forget it. After all registration steps are completed, it is recommended to wait 10 minutes before logging in.
                  </p>`,
        ru: `
        <div class="title-box">Процесс покупки VPS</div>
                  <p class="bold">
                      Параметры продукта VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Этапы подачи заявки на VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Откройте приложение WikiFX, войдите на домашнюю страницу, нажмите [VPS], чтобы начать процесс активации VPS.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Выберите необходимый облачный хост.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Выбрать сервер], лучше выбрать тот, который ближе всего к адресу сервера дилера. Его нельзя изменить после выбора. Если вам нужно изменить, выйдите из VPS и купите его снова.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Выберите язык VPS] выберите часто используемый язык системы.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Установите пароль вашего сервера.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Подтвердите информацию о заказе и оплатите золотыми монетами (золотые монеты необходимо приобретать в приложении).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Подтвердите информацию о заказе и запишите «IP-адрес сервера», «номер учетной записи» и «пароль». Рекомендуется сделать снимок экрана и сохранить его на случай, если вы его забудете. После завершения всех этапов регистрации рекомендуется подождать 10 минут перед входом в систему.
                          </p>
                      </li>
                  </ol>`,
        ja: `
        <div class="title-box">VPS購入の流れ</div>
                  <p class="bold">
                      VPS 製品パラメータ
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      VPSお申込み手順
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              WikiFX アプリを開き、ホームページに入り、[VPS] をクリックして VPS アクティベーションプロセスに入ります
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              必要なクラウドホストを選択します
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [サーバーの選択] では、ディーラーのサーバーアドレスに最も近いものを選択することをお勧めします。選択後は変更できません。変更する必要がある場合は、VPS からログアウトして、再度購入してください。
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [VPS 言語の選択] で、よく使用するシステム言語を選択します。
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              サーバーのパスワードを設定します
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <p>
                      6.注文情報を確認し、金貨で支払います（金貨はアプリ内で購入する必要があります）。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              注文情報を確認し、「サーバーIPアドレス」「アカウント番号」「パスワード」を記録してください。忘れた場合に備えてスクリーンショットを撮って保存することをお勧めします。 すべての登録手順が完了したら、10 分待ってからログインすることをお勧めします。
                          </p>
                      </li>
                  </ol>`,
        th: `
        <div class="title-box">ขั้นตอนการซื้อ VPS</div>
                  <p class="bold">
                      พารามิเตอร์ผลิตภัณฑ์ VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      ขั้นตอนการสมัคร VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              เปิดแอป WikiFX เข้าสู่หน้าแรก คลิก [VPS] เพื่อเข้าสู่กระบวนการเปิดใช้งาน VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              เลือกโฮสต์คลาวด์ที่ต้องการ
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [เลือกเซิร์ฟเวอร์] จะเป็นการดีกว่าถ้าเลือกอันที่ใกล้กับที่อยู่เซิร์ฟเวอร์ของดีลเลอร์มากที่สุด ไม่สามารถเปลี่ยนแปลงได้หลังจากเลือกแล้ว หากคุณต้องการเปลี่ยนแปลง ให้ออกจากระบบ VPS และซื้ออีกครั้ง
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [เลือกภาษา VPS] เลือกภาษาระบบที่คุณใช้บ่อย
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              ตั้งรหัสผ่านเซิร์ฟเวอร์ของคุณ
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              ยืนยันข้อมูลการสั่งซื้อของคุณและชำระเงินด้วยเหรียญทอง (ต้องซื้อเหรียญทองภายในแอป)
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              ยืนยันข้อมูลการสั่งซื้อและบันทึก &quot;ที่อยู่ IP ของเซิร์ฟเวอร์&quot;, &quot;หมายเลขบัญชี&quot; และ &quot;รหัสผ่าน&quot; ขอแนะนำให้จับภาพหน้าจอและบันทึกไว้ในกรณีที่คุณลืม หลังจากขั้นตอนการลงทะเบียนทั้งหมดเสร็จสิ้น ขอแนะนำให้รอ 10 นาทีก่อนเข้าสู่ระบบ
                          </p>
                      </li>
                  </ol>`,
        vi: `
        <div class="title-box">Quy trình mua VPS</div>
                  <p class="bold">
                      Thông số sản phẩm VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Các bước ứng dụng VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Mở APP WikiFX, vào trang chủ, nhấp vào [VPS] để vào quy trình kích hoạt VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Chọn máy chủ đám mây cần thiết
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Chọn Máy chủ], tốt hơn là chọn máy chủ gần nhất với địa chỉ máy chủ của đại lý. Không thể thay đổi sau khi chọn. Nếu bạn cần thay đổi, hãy đăng xuất khỏi VPS và mua lại.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Chọn ngôn ngữ VPS], chọn ngôn ngữ hệ thống bạn thường sử dụng.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Đặt mật khẩu máy chủ của bạn
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Xác nhận thông tin đặt hàng của bạn và thanh toán bằng tiền vàng (cần mua tiền vàng trong APP).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Xác nhận thông tin đơn hàng và ghi lại &quot;địa chỉ IP máy chủ&quot;, &quot;số tài khoản&quot; và &quot;mật khẩu&quot;. Bạn nên chụp ảnh màn hình và lưu lại phòng khi quên. Sau khi hoàn tất tất cả các bước đăng ký, bạn nên đợi 10 phút trước khi đăng nhập.
                          </p>
                      </li>
                  </ol>`,
        id: `
        <div class="title-box">Proses pembelian VPS</div>
                  <p class="bold">
                      Parameter produk VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Langkah-langkah aplikasi VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Buka APLIKASI WikiFX, masuk ke halaman beranda, klik [VPS] untuk masuk ke proses aktivasi VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Pilih host cloud yang diperlukan
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Pilih Server], sebaiknya pilih yang paling dekat dengan alamat server dealer. Tidak dapat diubah setelah dipilih. Jika perlu, logout dari VPS dan beli lagi.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Pilih bahasa VPS], pilih bahasa sistem yang umum Anda gunakan.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Tetapkan kata sandi server Anda
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Konfirmasikan informasi pesanan Anda dan bayar dengan koin emas (koin emas perlu dibeli di dalam APP).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Konfirmasikan informasi pesanan dan catat &quot;alamat IP server&quot;, &quot;nomor akun&quot; dan &quot;kata sandi&quot;. Disarankan untuk mengambil tangkapan layar dan menyimpannya jika Anda lupa. Setelah semua langkah pendaftaran selesai, disarankan menunggu 10 menit sebelum login.
                          </p>
                      </li>
                  </ol>`,
        es: `
        <div class="title-box">Proceso de compra de VPS</div>
                  <p class="bold">
                      Parámetros del producto VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Pasos para la solicitud de VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Abra la APLICACIÓN WikiFX, ingrese a la página de inicio, haga clic en [VPS] para ingresar al proceso de activación de VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Seleccione el host en la nube requerido
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Seleccionar servidor], es mejor elegir el más cercano a la dirección del servidor del distribuidor. No se puede cambiar después de la selección. Si necesita cambiar, cierre sesión en el VPS y cómprelo nuevamente.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Seleccione el idioma de VPS], seleccione el idioma del sistema que utiliza habitualmente.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Establece la contraseña de tu servidor
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirme la información de su pedido y pague con monedas de oro (las monedas de oro deben comprarse dentro de la APLICACIÓN).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirme la información del pedido y registre la &quot;dirección IP del servidor&quot;, el &quot;número de cuenta&quot; y la &quot;contraseña&quot;. Se recomienda tomar una captura de pantalla y guardarla en caso de que la olvide. Una vez completados todos los pasos de registro, se recomienda esperar 10 minutos antes de iniciar sesión.
                          </p>
                      </li>
                  </ol>`,
        hi: `
        <div class="title-box">वीपीएस खरीद प्रक्रिया</div>
                  <p class="bold">
                      वीपीएस उत्पाद पैरामीटर
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      वीपीएस आवेदन चरण
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              विकीएफएक्स ऐप खोलें, होमपेज दर्ज करें, वीपीएस सक्रियण प्रक्रिया में प्रवेश करने के लिए [वीपीएस] पर क्लिक करें
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              आवश्यक क्लाउड होस्ट का चयन करें
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [सर्वर का चयन करें], डीलर के सर्वर पते के निकटतम को चुनना बेहतर है। चयन के बाद इसे बदला नहीं जा सकता है। यदि आपको बदलने की आवश्यकता है, तो वीपीएस से लॉग आउट करें और इसे फिर से खरीदें।
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [वीपीएस भाषा चुनें], अपनी आमतौर पर इस्तेमाल की जाने वाली सिस्टम भाषा चुनें।
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              अपना सर्वर पासवर्ड सेट करें
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              अपने ऑर्डर की जानकारी की पुष्टि करें और सोने के सिक्कों से भुगतान करें (सोने के सिक्के एपीपी के भीतर खरीदने होंगे)।
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              ऑर्डर की जानकारी की पुष्टि करें और &quot;सर्वर आईपी पता&quot;, &quot;खाता संख्या&quot; और &quot;पासवर्ड&quot; रिकॉर्ड करें। यदि आप इसे भूल जाते हैं तो स्क्रीनशॉट लेने और इसे सहेजने की अनुशंसा की जाती है। सभी पंजीकरण चरण पूरे होने के बाद, लॉग इन करने से पहले 10 मिनट तक प्रतीक्षा करने की अनुशंसा की जाती है।
                          </p>
                      </li>
                  </ol>`,
        fil: `
        <div class="title-box">Proseso ng pagbili ng VPS</div>
                  <p class="bold">
                      Mga parameter ng produkto ng VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Mga hakbang sa aplikasyon ng VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Buksan ang WikiFX APP, ipasok ang homepage, i-click ang [VPS] para makapasok sa proseso ng pag-activate ng VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Piliin ang kinakailangang cloud host
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Piliin ang Server], mas mabuting piliin ang pinakamalapit sa address ng server ng dealer.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Piliin ang wika ng VPS], piliin ang iyong karaniwang ginagamit na wika ng system.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Itakda ang password ng iyong server
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Kumpirmahin ang impormasyon ng iyong order at magbayad gamit ang mga gintong barya (kailangang bilhin ang mga gintong barya sa loob ng APP).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Kumpirmahin ang impormasyon ng order at itala ang &quot;server IP address&quot;, &quot;account number&quot; at &quot;password&quot;. Inirerekomenda na kumuha ng screenshot at i-save ito kung sakaling makalimutan mo ito. Matapos makumpleto ang lahat ng mga hakbang sa pagpaparehistro, inirerekumenda na maghintay ng 10 minuto bago mag-log in.
                          </p>
                      </li>
                  </ol>`,
        fr: `
        <div class="title-box">Processus d'achat de VPS</div>
                  <p class="bold">
                      Paramètres du produit VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Étapes de demande de VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Ouvrez l&#39;application WikiFX, entrez dans la page d&#39;accueil, cliquez sur [VPS] pour accéder au processus d&#39;activation VPS.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Sélectionnez l&#39;hôte cloud requis
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Sélectionner le serveur], il est préférable de choisir celui le plus proche de l&#39;adresse du serveur du revendeur. Il ne peut pas être modifié après la sélection. Si vous devez le modifier, déconnectez-vous du VPS et achetez-le à nouveau.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Sélectionner la langue VPS], sélectionnez la langue système couramment utilisée.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Définissez le mot de passe de votre serveur
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirmez les informations de votre commande et payez avec des pièces d&#39;or (les pièces d&#39;or doivent être achetées dans l&#39;APP).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirmez les informations de commande et enregistrez « l&#39;adresse IP du serveur », le « numéro de compte » et le « mot de passe ». Il est recommandé de prendre une capture d&#39;écran et de la sauvegarder au cas où vous l&#39;oublieriez. Une fois toutes les étapes d&#39;inscription terminées, il est recommandé d&#39;attendre 10 minutes avant de vous connecter.
                          </p>
                      </li>
                  </ol>`,
        de: `
        <div class="title-box">VPS-Kaufprozess</div>
                  <p class="bold">
                      VPS-Produktparameter
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      VPS-Anwendungsschritte
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Öffnen Sie die WikiFX-App, rufen Sie die Startseite auf und klicken Sie auf [VPS], um den VPS-Aktivierungsprozess aufzurufen
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Wählen Sie den gewünschten Cloud-Host aus
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Server auswählen], es ist besser, den Server auszuwählen, der der Serveradresse des Händlers am nächsten liegt. Wenn Sie einen Wechsel vornehmen müssen, melden Sie sich vom VPS ab und kaufen Sie ihn erneut.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [VPS-Sprache auswählen], wählen Sie Ihre häufig verwendete Systemsprache aus.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Legen Sie Ihr Serverpasswort fest
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Bestätigen Sie Ihre Bestellinformationen und bezahlen Sie mit Goldmünzen (Goldmünzen müssen innerhalb der APP gekauft werden).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Bestätigen Sie die Bestellinformationen und notieren Sie die „Server-IP-Adresse“, „Kontonummer“ und „Passwort“. Es wird empfohlen, einen Screenshot zu machen und ihn zu speichern, falls Sie ihn vergessen. Nachdem alle Registrierungsschritte abgeschlossen sind, wird empfohlen, 10 Minuten zu warten, bevor Sie sich anmelden.
                          </p>
                      </li>
                  </ol>`,
        pt: `
        <div class="title-box">Processo de compra de VPS</div>
                  <p class="bold">
                      Parâmetros do produto VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      Etapas da aplicação VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Abra o APP WikiFX, entre na página inicial, clique em [VPS] para entrar no processo de ativação do VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Selecione o host de nuvem necessário
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Selecionar Servidor], é melhor escolher aquele mais próximo do endereço do servidor do revendedor. Não pode ser alterado após a seleção. Se precisar alterar, saia do VPS e compre-o novamente.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Selecionar idioma VPS], selecione o idioma do sistema comumente usado.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Defina a senha do seu servidor
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirme as informações do seu pedido e pague com moedas de ouro (as moedas de ouro precisam ser adquiridas dentro do APP).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Confirme as informações do pedido e registre o “endereço IP do servidor”, “número da conta” e “senha”. Recomenda-se fazer uma captura de tela e salvá-la caso você esqueça. Após a conclusão de todas as etapas de registro, é recomendável aguardar 10 minutos antes de fazer login.
                          </p>
                      </li>
                  </ol>`,
        tr: `
        <div class="title-box">VPS satın alma süreci</div>
                  <p class="bold">
                      VPS ürün parametreleri
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      VPS başvuru adımları
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              WikiFX APP&#39;yi açın, ana sayfaya girin, VPS aktivasyon işlemine girmek için [VPS]&#39;ye tıklayın
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Gerekli bulut ana bilgisayarını seçin
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [Sunucu Seçin], bayinin sunucu adresine en yakın olanı seçmek daha iyidir. Seçimden sonra değiştirilemez. Değiştirmeniz gerekiyorsa VPS&#39;den çıkış yapın ve tekrar satın alın.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [VPS dilini seçin], yaygın olarak kullandığınız sistem dilini seçin.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Sunucu şifrenizi belirleyin
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Sipariş bilgilerinizi onaylayın ve altın paralarla ödeme yapın (altın paraların uygulama içinden satın alınması gerekir).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              Sipariş bilgilerini onaylayıp &quot;sunucu IP adresi&quot;, &quot;hesap numarası&quot; ve &quot;şifre&quot;yi kaydedin. Ekran görüntüsünü alıp unutmanız durumunda kaydetmeniz önerilir. Tüm kayıt adımları tamamlandıktan sonra giriş yapmadan önce 10 dakika beklemeniz tavsiye edilir.
                          </p>
                      </li>
                  </ol>`,
        ko: `
        <div class="title-box">VPS 구매 과정</div>
                  <p class="bold">
                      VPS 제품 매개변수
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      VPS 신청 단계
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              WikiFX 앱을 열고 홈페이지에 들어간 후 [VPS]를 클릭하여 VPS 활성화 프로세스로 들어갑니다.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              필요한 클라우드 호스트를 선택하세요
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [서버 선택]은 대리점의 서버 주소와 가장 가까운 것을 선택하는 것이 좋습니다. 선택 후 변경할 수 없습니다. 변경이 필요한 경우에는 VPS에서 로그아웃한 후 다시 구매하세요.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [VPS 언어 선택]에서 일반적으로 사용되는 시스템 언어를 선택하십시오.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              서버 비밀번호를 설정하세요
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              주문 정보를 확인하고 금화로 결제합니다. (금화는 APP 내에서 구매해야 합니다.)
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              주문 정보를 확인하고 &quot;서버 IP 주소&quot;, &quot;계정 번호&quot;, &quot;비밀번호&quot;를 기록해 두시기 바랍니다. 모든 등록 단계가 완료되면 10분 정도 기다린 후 로그인하는 것이 좋습니다.
                          </p>
                      </li>
                  </ol>`,
        ar: `
        <div class="title-box">عملية شراء VPS</div>
                  <p class="bold">
                      معلمات منتج VPS
                  </p>
                  <p class="m30">
                      <img class="w80" src="${require('~/assets/img/help/buy-icon2-en.png')}"/>
                  </p>
                  <p class="bold">
                      خطوات تطبيق VPS
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              افتح تطبيق WikiFX، وادخل إلى الصفحة الرئيسية، وانقر فوق [VPS] للدخول إلى عملية تنشيط VPS
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon3-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              حدد المضيف السحابي المطلوب
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon4-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [اختر الخادم]، من الأفضل اختيار الخادم الأقرب إلى عنوان خادم الموزع، ولا يمكن تغييره بعد التحديد. إذا كنت بحاجة إلى التغيير، فقم بتسجيل الخروج من VPS وقم بشرائه مرة أخرى.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon5-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              [اختر لغة VPS]، حدد لغة النظام شائعة الاستخدام.
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon6-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              قم بتعيين كلمة مرور الخادم الخاص بك
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon7-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              قم بتأكيد معلومات طلبك والدفع بالعملات الذهبية (يجب شراء العملات الذهبية داخل التطبيق).
                          </p>
                      </li>
                  </ol>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/buy-icon8-en.png')}"/>
                  </p>
                  <ol class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              قم بتأكيد معلومات الطلب وتسجيل &quot;عنوان IP للخادم&quot; و&quot;رقم الحساب&quot; و&quot;كلمة المرور&quot;. ويوصى بالتقاط لقطة للشاشة وحفظها في حالة نسيانها. بعد الانتهاء من جميع خطوات التسجيل، يوصى بالانتظار لمدة 10 دقائق قبل تسجيل الدخول.
                          </p>
                      </li>
                  </ol>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40598'),
      meta: [
        { name: 'Description', content: this.$t('40589') }
      ]
    }
  }
}
